import { handleActions } from 'redux-actions';

import { actions } from '../actions/conversations';
import { originalEmailActions } from '../actions/originalEmail';

const { originalEmailGetHtmlMessageSucceeded } = originalEmailActions;

export type EmailMessageType = {
  rewritten_html: string;
  messageId: string;
  csid: number;
};

type EmailMessagesType = {
  messages: Array<EmailMessageType>;
};

export const { conversationsRemove } = actions;

export const initialState: EmailMessagesType = {
  messages: [],
};

// Reducer
const emailMessages = handleActions<EmailMessagesType, any>(
  {
    [conversationsRemove.toString()]: (
      state: EmailMessagesType,
      action: { payload: number },
    ) => {
      const csid = action.payload;

      return {
        ...state,
        messages: state.messages.filter(
          (m: EmailMessageType) => m.csid !== csid,
        ),
      };
    },

    [originalEmailGetHtmlMessageSucceeded.toString()]: (
      state: EmailMessagesType,
      action: {
        payload: {
          msg?: any;
          rewritten_html?: string;
          csid: number;
          messageId: string;
        };
      },
    ) => {
      // `contactform` conversation type seem to have all of the message attributes in a root level
      const rewritten_html = action.payload.msg
        ? action.payload.msg.rewritten_html
        : action.payload.rewritten_html;
      const csid = action.payload.csid;
      const messageId = action.payload.messageId;

      if (rewritten_html) {
        return {
          ...state,
          messages: [
            ...state.messages,
            {
              rewritten_html: rewritten_html,
              messageId: messageId,
              csid: csid,
            },
          ],
        };
      }
      return state;
    },
  },
  initialState,
);

export default emailMessages;
